export const urls = {
  login: '/login',

  home: '/',

  flightDetails: '/flug',
  hotelDetails: '/hotel',
  payment: '/bezahlung',
  documents: '/dokumente',
  transfer: '/transfer',
  insurance: '/versicherung',

  contact: '/kontakt',
  entryConditions: '/einreise-bestimmungen',
  weather: '/wetter',
  map: '/karte',
  upgrades: '/upgrades',
  peopleAndPlaces: '/land-und-leute',

  imprint: '/impressum',
  dataProtection: '/datenschutz',
  about: '/info',
  termsAndConditions: '/agb',

  sitemap: '/funktionen',
  weather: '/wetter',

  rentalCar: '/mietwagen',
  limousineService: '/limousinen-service',

  airportParking: '/flughafen-parken',

  excursions: {
    index: '/excursions',
    details: '/excursions/:code',
    booking: '/excursions/:code/buchen',
    status: '/excursions/buchung',
    mts: '/excursions/mts',
  },

  api: {
    documents: '/api/bookings/documents',
    tracking: '/api/transfer/tracking?distributorCode=',
    transfer: '/api/transfer',
    bookings: '/api/bookings',
    clientContacts: '/api/bookings/client-contacts',
  },
};
